import { useState } from "react";

import { ErrorDisplay } from "../ErrorDisplay";

interface AudioPlayerProps {
  dataUrl: string;
}

export const AudioPlayer = ({ dataUrl }: AudioPlayerProps) => {
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium">Audio Player</div>

      {error && <ErrorDisplay title="Failed to load audio" message={error} />}

      <audio
        src={dataUrl}
        controls
        className="w-full"
        onError={() => {
          setError(
            "Unable to load audio. The file may be corrupted or the browser doesn't support this audio format.",
          );
        }}
        onLoadStart={() => setError(null)}
      >
        Your browser does not support the audio tag.
      </audio>
    </div>
  );
};
